import { Weekdays } from "../../../../components/FacilityManager/Domain/Types/Booking/Weekdays.type";
import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import { MaxSetUpTime } from "../../../../features/Booking-Form/typings/booking-services.types";
import { useRemoteQuery } from "../../useRemote/useRemoteQuery";

type BookingFilterDto = {
  bookingInventoryIds: number[];
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  bookingType: BookingType;
  timezone: string;
  monday: string;
  weekdays?: Weekdays;
};

export function useRemoteFetchMaxSetupTime(bookingFilterDto: BookingFilterDto, enabled: boolean) {
  return useRemoteQuery<MaxSetUpTime>({
    queryKey: ["booking-service-max-set-up-time"],
    url: "booking/max-set-up-time",
    params: bookingFilterDto,
    enabled: enabled
  });
}
